import React from 'react'
import { HeadingText, TitleText } from '@paypalcorp/pp-react'

import { LOCATORS } from 'constants/automation'
import { SectionType } from 'shoplist-app/shopping/types/ShoppingPageType'
import './pageTitle.scss'
import TextWithLinks from 'components/TextWithLinks/TextWithLinks'

type PageTitleProps = Pick<SectionType, 'title' | 'subtitle'>

const PageTitle = ({ title, subtitle }: PageTitleProps) => {
  return (
    <div data-cy={LOCATORS.PAGE_TITLE}>
      <HeadingText
        data-cy={LOCATORS.PAGE_TITLE__TITLE}
        className="page-title__title"
        size="sm"
      >
        {title}
      </HeadingText>
      <TitleText data-cy={LOCATORS.PAGE_TITLE__SUBTITLE}>
        <TextWithLinks
          text={subtitle}
          linkProps={{ style: { fontSize: 'inherit' } }}
        />
      </TitleText>
    </div>
  )
}

export default PageTitle
